module.exports={
    header: {
        icon:{
            icon:'/static/images/store_03.png',
            // store:'/static/images/store_06.png',
            // system:'/static/images/store_08.png',
            // template:'/static/images/store_10.png'
        },
        store:'门店',
        system:'系统',
        template:'模板',
        personInfo:'个人信息',
        systemMsg:'版本信息',
        quit:'退出',
        switch:'中/英/日',
        dialogTitle:'版本',
        dialog:{
            sure:'确 定',
            cancel:'取 消'
        },
        hintMsg:{
            queryFail:'查询用户信息失败',
            frontendVersion:'前端版本：{version}',
            backendVersion:'后端版本：{version}'
        },
        quitMsg: '确定退出吗?'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/Header.js